<template>
  <v-container>

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container fluid pa-0 pb-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div class="mt-4 pl-4 pr-4 pt-4">

          <v-row align-center>
            <div class="display-1 mt-4">
              Invoices
            </div>
            <v-spacer></v-spacer>

            <v-btn>
              Reporting
            </v-btn>

            <v-tooltip bottom open-delay="200">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="showSettings = !showSettings">
                  <v-icon>mdi-settings</v-icon>
                </v-btn>
              </template>
              <span>Settings</span>
            </v-tooltip>

          </v-row>

          <v-card>
            <reporting></reporting>
          </v-card>

          <v-slide-y-transition
          class="py-0"
          >
          <v-card v-if="showSettings" class="ma-4">
            <invoice-settings></invoice-settings>
          </v-card>
          </v-slide-y-transition>

          <v-tabs v-model="activeTab" centered>
            <v-tab>In process</v-tab>
            <v-tab>Complete</v-tab>
          </v-tabs>
        </div>

      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container fluid class="pa-0">
        <invoices-in-process v-if="activeTab === 0"></invoices-in-process>
        <!-- <sales-complete v-if="activeTab === 1"></sales-complete> -->
      </v-container>
    </div>

  </v-container>
</template>

<script>
// import SalesComplete from './SalesComplete'
import InvoicesInProcess from './InvoicesInProcess'
import InvoiceSettings from './invoice-settings'
import Reporting from './reporting/MainBlock'

export default {
  name: 'productions',
  components: {
    InvoicesInProcess,
    InvoiceSettings,
    Reporting
  },
  data () {
    return {
      activeTab: 0,
      showSettings: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>

